import axios from "axios";
import {db_url, url_active_routes, url_route_depend,} from "../url";

export default function DB_Route (token) {
    const url = '/dictionary/trade-point/routes'
    const formData = new FormData;
    formData.append('token', token);

    // const appendToken = (data) => {
    //     const fd = new FormData;
    //     for (const pair of data.entries()) {
    //         fd.append(pair[0], pair[1]);
    //     }
    //     fd.append('token', token);
    //     return fd
    // }



    const getRoutes = (controller, search) => {
        return axios.get(db_url + url, {
        // return axios.get('http://127.0.0.1:3002/api_web/v1' + url , {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getActiveRoutes = () => {
        return axios.post(url_active_routes, formData)
    }

    const getRoute = (id) => {
        return axios.get( db_url + url, {
        // return axios.get( "http://127.0.0.1:3002/api_web/v1" + url, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }


    const saveRoute = (data) => {
        return axios.post( db_url + url, data,{
        // return axios.post( "http://127.0.0.1:3002/api_web/v1" + url, data,{
            headers: {
                Authorization: token
            }
        })
    }


    // const updateRoute = (data) => {
    //     return axios.put(url_route, appendToken(data))
    // }


    const changeStatusRoute = (id) => {
        return axios.put(db_url + url, null, {
        // return axios.put('http://127.0.0.1:3002/api_web/v1' + url, null, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const deleteRoute = (id) => {
        return axios.delete(db_url + url, {
        // return axios.delete('http://127.0.0.1:3002/api_web/v1' + url,  {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const dependRoute = (id) => {
        return new Promise(resolve => {
            axios.get(url_route_depend + id)
                .then(res => {
                    if(res.status === 200){
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                })
        })
    }


    return {
        getRoutes,
        getActiveRoutes,
        getRoute,
        saveRoute,
        changeStatusRoute,
        deleteRoute,
        dependRoute,
    }
}
